import { useState } from "react";
import classNames from "classnames/bind";
import { useRouter } from "next/router";
import { getUrlLocale } from "@/core/utils";
import LanguageSelectIcon from "@/assets/svg/language-select.svg";
import { GetPageWrapperDataQuery } from "@/__generated__/graphql";

import styles from './LanguageRadioSelect.module.scss';
const cx = classNames.bind(styles);


type Languages = GetPageWrapperDataQuery["languages"];
type OptionProps = Languages[number] & {
  onChange: (code: string) => void;
  checked: boolean;
};
type LanguageRadioSelectProps = {
  languages: Languages;
}

const Option = ({ code, native_name, onChange, checked }: OptionProps) => {
  return (
    <label className={cx("language-option")}>
      <input type="radio" name="language" value={code} checked={checked} onChange={() => onChange(code)} />
      <span className={cx("circle")} />
      <p className={cx(["text-m", "label"])}>{native_name}</p>
    </label>
  )
}

export default function LanguageRadioSelect({ languages }: LanguageRadioSelectProps) {
  const router = useRouter();
  const [value, setValue] = useState(getUrlLocale(router.asPath) || 'en');

  const onSelectChange = (newValue: string) => {
    setValue(newValue);
    const currentPath = router.asPath;
    const currentLocale = getUrlLocale(currentPath);
    const newLocale = newValue;
    let newPath = currentLocale ? currentPath.split(`/${currentLocale}`)[1] || '/' : currentPath;
    if (newLocale !== 'en') newPath = `/${newLocale}${newPath}`;
    window.location.href = newPath;
  }
  return (
    <div className={cx("language-radio-select")}>
      <div className={cx("content")}>
        <LanguageSelectIcon className={cx("icon")} />
        <p className="eyebrow-s">Language</p>
      </div>
      <div className={cx("language-options")}>
        {languages.map((lang) => (
          <Option key={lang.code} {...lang} onChange={onSelectChange} checked={value === lang.code} />
        ))}
      </div>
    </div>
  );
};